let compactNumberCache: Map<number, Intl.NumberFormat> | undefined;

/**
 * A compact figure with up to `maximumFractionDigits` places and no
 * trailing zeros: "850K", "1.2M". `Intl` picks the unit after rounding, so
 * 999,999 reads "1M", never "1000K".
 */
export function formatCompactNumber(
  value: number,
  { maximumFractionDigits = 1 }: { maximumFractionDigits?: number } = {}
): string {
  compactNumberCache ??= new Map();
  let formatter = compactNumberCache.get(maximumFractionDigits);
  if (!formatter) {
    formatter = new Intl.NumberFormat('en-US', {
      notation: 'compact',
      minimumFractionDigits: 0,
      maximumFractionDigits
    });
    compactNumberCache.set(maximumFractionDigits, formatter);
  }
  return formatter.format(value);
}
